/*
 * @description: 微信用户管理接口
 * @author: fuping
 * @date: 2021-08-11 14:05:18
 * @version: V1.0.5
 */
import http from "@/promise/http";
const CONTROLLER_NAME = "/wechat/";

/**
 *@description:注册、注销微信用户
 *@author: fuping
 *@date: 2021-08-11 14:06:35
 */
export const registrationOrCancellation = (user) => {
  return http.post(CONTROLLER_NAME.concat("registrationOrCancellation"), user);
};

/**
 *@description:统计信息
 *@author: fuping
 *@date: 2021-08-16 11:21:16
 */
export const summaryData = (user) => {
  return http.post(CONTROLLER_NAME.concat("summaryData"), user);
};

/**
 *@description:统计信息班组
 *@author: fuping
 *@date: 2021-08-16 11:21:16
 */
export const teamAttendanceData = (user) => {
  return http.post(CONTROLLER_NAME.concat("teamAttendanceData"), user);
};

/**
 *@description:发送验证码
 *@author: fuping
 *@date: 2021-08-11 14:08:36
 */
export const sendCode = (phone) => {
  return http.post("/publicServer/sendSms", phone);
};
